var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1401 0.960043L5.11012 3.96004C-0.959883 5.99004 -0.959883 9.30004 5.11012 11.32L7.79012 12.21L8.68012 14.89C10.7001 20.96 14.0201 20.96 16.0401 14.89L19.0501 5.87004C20.3901 1.82004 18.1901 -0.389957 14.1401 0.960043ZM14.4601 6.34004L10.6601 10.16C10.5101 10.31 10.3201 10.38 10.1301 10.38C9.94012 10.38 9.75012 10.31 9.60012 10.16C9.46064 10.0189 9.38242 9.82847 9.38242 9.63004C9.38242 9.43161 9.46064 9.24118 9.60012 9.10004L13.4001 5.28004C13.6901 4.99004 14.1701 4.99004 14.4601 5.28004C14.7501 5.57004 14.7501 6.05004 14.4601 6.34004Z",
    fill: "#0020BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.292a162d3cb1a6f999d26a18a111ed4a.svg";
export { ForwardRef as ReactComponent };